/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
import * as React from 'react';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import {
  Grid,
  makeStyles,
  TextareaAutosize,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import NewSelect from '../selectBox/NewSelect';
import { AgapeTextField } from '../typography';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'Vazir',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#acacac',
    marginTop: '20px',
  },
  textField: {
    width: '85%',
    minWidth: '85%',
    maxWidth: '85%',
  },

  title2: {
    fontSize: '14px',
    fontFamily: 'Vazir-Bold',
    marginTop: '-5px',
    marginBottom: '-15px',
  },
  dateFild2: {
    textAlign: 'left',
    fontFamily: 'Vazir !important',
    marginBottom: '10px',
    width: '92%',
    // display: 'block',
    marginTop: '11px',
    height: '40px',
    borderRadius: '6px',
    transition: 'box-shadow .15s ease',
    position: 'relative !important',
  },
  dateFild3: {
    textAlign: 'left',
    fontFamily: 'Vazir !important',
    marginBottom: '10px',
    width: '92%',
    // display: 'block',
    marginTop: '11px',
    height: '40px',
    borderRadius: '6px',
    transition: 'box-shadow .15s ease',
    position: 'absolute !important',
    zIndex: '-9999',
  },
  star: {
    content: '"*"',
    color: '#f00',
  },
  txtFild: {
    display: 'block',
    // minWidth: '100%',
    // maxWidth: '100%',
    minHeight: '90px',
    maxHeight: '90px',
    borderRadius: '10px',
    fontFamily: 'Vazir',
    fontSize: '16px',
    padding: '10px',
    marginTop: '20px',

    boxShadow: '0 1px 3px rgba(50,50,93,.15), 0 1px 0 rgba(0,0,0,.02)',
    border: 'solid 1px #f8f9fe',
  },
  calendarClassName: {
    zIndex: '9999',
  },
}));

const numbers = /^(|[0-9]\d*)$/;

const AgapeForm = ({
  fields,
  title,
  col,
  colXs,
  publics,
  titleClassName,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      {title && (
        <Grid item md={12}>
          <Typography
            className={clsx(classes.title, titleClassName && titleClassName)}
          >
            {title}
          </Typography>
        </Grid>
      )}

      {fields && fields.length > 0
        ? fields.map((item) =>
            item ? (
              <Grid key={item.name} item xs={colXs && colXs} md={col}>
                {!item.type ? (
                  <AgapeTextField
                    name={item.name}
                    dir={item.dir || 'rtl'}
                    error={item.errors}
                    fullWidth={item.fullWidth}
                    disabled={item.disabled}
                    variant="outlined"
                    native={publics}
                    legend={item.label}
                    editable={!item.star}
                    placeholder={item.placeholder}
                    value={item.value}
                    onKeyDown={item.onKeyDown}
                    InputProps={{
                      endAdornment: item.icon,
                    }}
                    onChange={
                      item.isNumber
                        ? (e) =>
                            numbers.test(e.target.value)
                              ? item.onChange(e)
                              : null
                        : item.onChange
                    }
                    classNameCustom={clsx(
                      classes.textField,
                      item.className && item.className
                    )}
                    {...props}
                  />
                ) : item.type === 'select' ? (
                  <NewSelect
                    name={item.name}
                    value={item.value}
                    onChange={item.onChange}
                    onInputChange={item.onSearch}
                    required={item.star}
                    label={item.label}
                    placeholder={item.placeholder}
                    options={item.options}
                    defaultValue={item.defaultValue}
                    disabled={item.disabled}
                    native={publics}
                    fullWidth={item.fullWidth}
                    className={clsx(
                      classes.textField,
                      item.className && item.className
                    )}
                    {...props}
                  />
                ) : item.type === 'time' ? (
                  <AgapeTextField
                    name={item.name}
                    error={item.errors}
                    fullWidth={item.fullWidth}
                    disabled={item.disabled}
                    variant="outlined"
                    legend={item.label}
                    editable={!item.star}
                    placeholder={item.placeholder}
                    native={publics}
                    value={item.value}
                    onChange={item.onChange}
                    classNameCustom={clsx(
                      classes.textField,
                      item.className && item.className
                    )}
                    {...props}
                    type="time"
                  />
                ) : item.type === 'date' ? (
                  <>
                    <h2 className={classes.title2}>
                      {item.label}
                      {item.star ? (
                        <span className={classes.star}>*</span>
                      ) : null}
                    </h2>
                    <DatePicker
                      shouldHighlightWeekends
                      calendarPopperPosition={item.open ? item.open : 'auto'}
                      inputPlaceholder={item.placeholder}
                      disabled={item.disabled}
                      inputClassName={clsx(
                        classes.dateFild3,
                        item.className && item.className
                      )}
                      locale="fa"
                      wrapperClassName={clsx(
                        classes.dateFild2,
                        item.className && item.className
                      )}
                      value={item.value}
                      colorPrimary="#18c5bf" // added this
                      colorPrimaryLight="#18c5bf"
                      onChange={item.onChange}
                      name={item.name}
                      error={item.errors}
                      fullWidth={item.fullWidth}
                      native={publics}
                      calendarClassName={classes.calendarClassName}
                      {...props}
                    />
                  </>
                ) : item.type === 'textarea' ? (
                  <>
                    <h2 className={classes.title2}>
                      {item.label}
                      {item.star ? (
                        <span className={classes.star}>*</span>
                      ) : null}
                    </h2>
                    <TextareaAutosize
                      name={item.name}
                      onChange={item.onChange}
                      value={item.value}
                      placeholder={item.placeholder}
                      disabled={item.disabled}
                      className={clsx(
                        classes.textField,
                        classes.txtFild,
                        item.className && item.className
                      )}
                      {...props}
                    />
                    {item.errors ? (
                      <span className={classes.star}>{item.errors}</span>
                    ) : null}
                  </>
                ) : null}
              </Grid>
            ) : null
          )
        : null}
    </Grid>
  );
};

AgapeForm.prototypes = {
  fields: PropTypes.array,
  title: PropTypes.string,
  col: PropTypes.number,
  publics: PropTypes.bool,
};

export default AgapeForm;
